export default __webpack_public_path__ + "static/media/tools.138de78f.svg";